<template>
  <validation-observer ref="AddLabourForm" #default="{ invalid,errors }">
    <b-form @submit.prevent="editEquipment">
      <b-row>
        <b-col md="6">
          <b-form-group label="Equipment Code" label-for="mc-first-name">
            <validation-provider
              #default="{ errors }"
              name="Equipment Code"
              vid="Equipment Code"
              rules="required"
            >
              <b-form-input
                id="mc-first-name"
                placeholder="Equipment Code"
                v-model="equipment.assetCode"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Equipment Name" label-for="mc-last-name">
            <validation-provider
              #default="{ errors }"
              name="Equipment Name"
              vid="Equipment Name"
              rules="required"
            >
              <b-form-input
                id="mc-last-name"
                placeholder="Equipment Name"
                v-model="equipment.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Equipment Description" label-for="mc-city">
            <b-form-textarea
              id="textarea-default"
              placeholder="Equipment Description"
              rows="3"
              v-model="equipment.description"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Supplier" label-for="mc-Supplier">
            <b-form-select
              v-model="equipment.supplierId"
              :options="suppliers"
              value-field="id"
              text-field="name"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Staff" label-for="mc-Staff">
            <b-form-select
              v-model="equipment.staffId"
              :options="staffOptions"
              value-field="id"
              text-field="firstName"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Purchase Date" label-for="mc-purchase">
            <b-form-datepicker
              id="example-purchase"
              class="mb-1"
              v-model="equipment.purchaseDate"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Expiry Date" label-for="mc-expiry">
            <b-form-datepicker
              id="example-expiry"
              v-model="equipment.lifeEndDate"
              class="mb-1"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Maintenance Date" label-for="mc-maintainance">
            <b-form-datepicker
              id="example-maintainance"
              v-model="equipment.maintainanceDate"
              class="mb-1"
            />
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group label="Location" label-for="mc-last-name">
           
              <b-form-input
                id="mc-last-name"
                placeholder="Location"
                v-model="equipment.location"
              />
           
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Availability" label-for="mc-last-name">
            <b-form-select
              v-model="equipment.status"
              :options="optionsDLL"
              @change="addNote(equipment.status)"
            />
          </b-form-group>
        </b-col>
        <!-- Equipment Document -->
        <b-col md="3" class="d-flex justify-content-end">
          <b-form-group style="margin-top: 20px">
            <b-button
              variant="primary"
              @click="handleEquipmentDocBtn(equipment.id)"
              >Documents</b-button
            >
            <b-spinner
              class="mt-1"
              variant="success"
              label="Spinning"
              block
              v-if="loading"
              style="width: 3rem; height: 3rem; margin-left: 32px"
            ></b-spinner>
          </b-form-group>
          <b-modal
            ref="modal-view-equipment-document"
            id="modal-view-equipment-document"
            ok-only
            ok-title="View"
            centered
            size="lg"
            title="View Equipment Documents"
            :hide-footer="true"
          >
            <DocumentUpload
              @deleteFile="deleteFile"
              @downloadFile="downloadFile"
              @uploadFiles="uploadFiles"
              :documentDetails="documentDetails"
            />
          </b-modal>
        </b-col>
        <!-- Equipment Document -->
        <b-col md="6">
          <b-form-group label="Cost Per Hour">
            <b-form-input
              type="number"
              placeholder="Cost / Hour (RS)"
              v-model="equipment.costPerHour"
              step="0.01"
              required
            />
          </b-form-group>
        </b-col>

        <!-- For notes Start-->
        <b-col md="12" class="d-flex justify-content-end">
          <b-button
            type="button"
            variant="primary"
            @click="addNote(defaultAddNoteStatus)"
            :disabled="invalid"
            >Add notes</b-button
          >
        </b-col>

        <b-col
          md="12"
          v-if="equipment.notes && equipment.notes.length > 0"
          class="mt-2"
        >
          <b-col md="3" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="equipment.notes"
            :fields="noteFields"
          >
            <template #cell(user)="data">
              <span>{{ data.item.user }}</span>
            </template>
            <template #cell(note)="data">
              <validation-provider v-if="isEditable(data.item)" rules="required" label="Note" :vid="data.item.id" #default="{ errors }" name="Note">
              <b-form-input
                v-model="data.item.note"
                placeholder="Enter notes"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
              <b-form-input v-else
                v-model="data.item.note"
                :readonly="!isEditable(data.item)"
                placeholder="Enter notes"
              ></b-form-input>
            </template>
            <template #cell(noteDate)="data">
              {{ formatDate(data.item.noteDate) }}
            </template>
          </b-table>
          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="equipment.notes.length"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
        </b-col>
        <!-- For notes End-->
        <!-- submit and reset -->
        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="submit" variant="primary" :disabled="loading"
            ><b-spinner small v-if="loading" class="mx-2" />Submit</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BPagination,
  BModal,
  VBModal,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import DocumentUpload from "../component/DocumentUpload.vue";
import Ripple from "vue-ripple-directive";
import {
  deleteEquipmentDocument,
  uploadMultipleEquipmentDocuments,
  uploadDocument,
  downloadEquipmentDocument,
} from "@/store/equipment/services";
import { customSwal, customError, fnSortingDropdown } from "@/libs/customFn";

export default {
  name: "AddEquipment",
  components: {
    BTable,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BPagination,
    DocumentUpload,
    BModal,
    VBModal,
    BDropdown,
    BDropdownItem,
  },
  props: {
    equipment: {
      type: Object,
      default: () => {
        return {
          notes: [],
        };
      },
    },
    directives: {
      Ripple,
      "b-modal": VBModal,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      dayjs,
      assetCode: "",
      purchaseDate: "",
      name: "",
      initialEquipmentStatus: 0,
      defaultAddNoteStatus: -0,
      description: "",
      lifeEndDate: "",
      maintainanceDate: "",
      location: "",
      supplierId: "",
      staffId: "",
      selected: 5,
      options: [
        { value: "1", text: "BOOKED" },
        { value: "2", text: "AVAILABLE" },
        { value: "3", text: "MAINTENANCE" },
        { value: "4", text: "BROKEN" },
        { value: "5", text: "NOT_AVAILABLE" },
      ],
      newNote: "",
      perPage: 5,
      currentPage: 0,
      pageOptions: [3, 5, 10],
      noteFields: [
        { key: "user", label: "User" },
        { key: "note", label: "Note" },
        { key: "noteDate", label: "Date" },
      ],
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
    };
  },
  computed: {
    ...mapGetters("equipmentModule", {
      documents: "documents",
      file: "file",
      loading: "loading",
    }),
    ...mapGetters("supplierModule", {
      suppliers: "suppliers",
      loading: "loading",
    }),
    ...mapGetters("userModule", {
      staffOptions: "users",
      loading: "loading",
    }),
    optionsDLL() {
      return fnSortingDropdown(this.options);
    },
  },
  async mounted() {
    await this.getSupplierListAction();
    await this.getUserListAction();
    this.initialEquipmentStatus = this.equipment.status;
  },

  methods: {
    success() {
      this.$swal({
        title: "Equipment updated!",
        text: "You have successfully updated the equipment!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    // error
    error() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    ...mapActions("equipmentModule", [
      "updateEquipmentAction",
      "getEquipmentDocumentListAction",
    ]),
    ...mapActions("supplierModule", ["getSupplierListAction"]),
    ...mapActions("userModule", ["getUserListAction"]),

    editEquipment() {
      this.$refs.AddLabourForm.validate().then((success) => {
        if (success) {
          this.loading = true;

          let payload = {
            id: this.equipment.id,
            assetCode: this.equipment.assetCode,
            purchaseDate: this.equipment.purchaseDate,
            name: this.equipment.name,
            description: this.equipment.description,
            lifeEndDate: this.equipment.lifeEndDate,
            maintainanceDate: this.equipment.maintainanceDate,
            location: this.equipment.location,
            isActive: true,
            status: this.equipment.status,
            costPerHour: this.equipment.costPerHour,
            supplierId: this.equipment.supplierId,
            staffId: this.equipment.staffId,
            notes: this.equipment.notes.filter((note) => !note.isExistingNote),
          };
          console.log("payload", payload);
          this.updateEquipmentAction(payload)
            .then(() => {
              this.success();
              this.$emit("refresh");
              this.$bvModal.hide("modal-edit");
              this.loading = true;
            })
            .catch(() => {
              this.error();
              this.$emit("refresh");
              this.loading = true;
              this.$bvModal.hide("modal-edit");
            });
        }
      });
    },

    addNote(status) {
      let finalStatus = "";
      if (status > 0) {
        const statusMapping = {
          1: "BOOKED",
          2: "AVAILABLE",
          3: "MAINTENANCE",
          4: "BROKEN",
          5: "NOT_AVAILABLE",
        };
        const fromStatus =
          statusMapping[this.initialEquipmentStatus] || "UNKNOWN";
        const toStatus = statusMapping[status] || "UNKNOWN";
        finalStatus = `Availability status changed from ${fromStatus} to ${toStatus}`;
      }
      const currentDate = new Date().toISOString();
      this.equipment.notes.push({
        id: uuidv4(),
        user: this.userData ? this.userData.fullName : "Unknown",
        note: status > 0 ? finalStatus : this.newNote,
        noteDate: currentDate,
        isExistingNote: false,
      });
      this.newNote = "";

      this.$nextTick(() => {
        const totalNotes = this.equipment.notes
          ? this.equipment.notes.length
          : 0;
        const maxPages = Math.ceil(totalNotes / this.perPage);

        if (this.currentPage < maxPages) {
          this.currentPage = maxPages;
        }
      });
    },

    isEditable(note) {
      return !note.isExistingNote;
    },
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    async handleEquipmentDocBtn(referenceId) {
      try {
        this.loading = true;
        await this.getEquipmentDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
          this.loading = false;
        }
        this.$refs["modal-view-equipment-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.equipment.id;
      if (selectedFiles.length > 0) {
        await uploadMultipleEquipmentDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
        await this.getEquipmentDocumentListAction(referenceId);
        this.documentDetails.isDelete = true;
        this.documentDetails.documentList = this.documents;
      } else {
        setTimeout(() => {
          this.$swal.close();
        }, 5000);
        customSwal("Please select file(s) to upload.", "Information", "");
        loader.close();
      }
    },

    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadEquipmentDocument(id);
        console.log("download: ", response);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        console.log("a link", link.href);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },

    async deleteFile(id) {
      console.log("deleteFile", id);
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteEquipmentDocument(id)
        .then((response) => {
          loader.close();
          customSwal("Document deleted successfully.");
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getEquipmentDocumentListAction(this.equipment.id);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-equipment-document");
      });
    },
  },
};
</script>
